export const TYPE_PAGINATION_ONE_ROWS = "one rows"
export const TYPE_PAGINATION_DOUBLE_ROWS = "double rows"

export const DOKTER_UMUM_ID = "120"
export const EXCEL_DEFAULT_SEPARATOR = ";"

/**
 * Cookies variable
 */
export const COOKIE_TOKEN = "token"
export const COOKIE_USER_NAME = "user_name"
export const COOKIE_USER_ID = "user_id"
export const COOKIE_LOCAL_IP = "local_ip"
export const COOKIE_TEMA = "tema"

export const COOKIE_EXPIRED = 0.2

export const TOKEN_TELEKONSUL =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjM5MSIsIm5hbWUiOiJBZGl0eWEgQWd1cyBXaXNhbnRvIiwiZW1haWwiOiJhZGl0eWEuYWd1c0ByYWhhcmphLmluZm8iLCJpc19iaW9kYXRhIjoxLCJhY3RpdmVfcnMiOjEsIm5vX3doYXRzYXBwIjoiNjI4OTY2NDQ3MzM1MiIsImlhdCI6MTY2ODU4MTM1Mn0.7hwYjE0bqQY5vemPELX47aZ2n3p7C0ix4g30Src9cVE"

export const DEFAULT_SHOW_BUTTON_SUBMIT = {
  label: "Simpan",
  color: "green",
  state: false,
  disabled: false,
}

export const valueTipePembayaran = [
  {
    value: 1,
    label: "TUNAI",
  },
  {
    value: 2,
    label: "DEBET/KREDIT",
  },
  {
    value: 3,
    label: "CLIENT/CLIENTAS",
  },
  {
    value: 4,
    label: "SALDO",
  },
  // 5 : KASBON DOKTER
  {
    value: 6,
    label: "PINJAMAN PEGAWAI (HRIS)",
  },
]

export const valueTipeKartu = [
  {
    value: 1,
    label: "DEBET",
  },
  {
    value: 2,
    label: "KREDIT",
  },
  {
    value: 3,
    label: "Lain-Lain",
  },
]

export const DEFAULT_SHOW_BUTTON_SEARCH = {
  label: "Cari",
  color: "green",
  state: false,
}

export const DISABLED_BUTTON_SUBMIT = {
  label: "Loading..",
  color: "secondary",
  state: true,
  disabled: true,
}

export const DEFAULT_VALUE_OPTION = (label) => {
  return {
    value: "",
    label: `Pilih ${label}`,
  }
}

export const DEFAULT_DAY_OPTION = [
  {
    value: "",
    label: "Pilih Hari",
  },
  {
    value: "monday",
    label: "Senin",
    number: "1",
  },
  {
    value: "tuesday",
    label: "Selasa",
    number: "2",
  },
  {
    value: "wednesday",
    label: "Rabu",
    number: "3",
  },
  {
    value: "thursday",
    label: "Kamis",
    number: "4",
  },
  {
    value: "friday",
    label: "Jumat",
    number: "5",
  },
  {
    value: "saturday",
    label: "Sabtu",
    number: "6",
  },
  {
    value: "sunday",
    label: "Minggu",
    number: "7",
  },
]

export const DEFAULT_STATUS_OPTION = [
  {
    value: "",
    label: "Pilih Status",
  },
  {
    value: true,
    label: "Aktif",
  },
  {
    value: false,
    label: "Tidak Aktif",
  },
]

export const convertDayToNumber = (str) => {
  if (str.toLowerCase() === "monday") {
    return 1
  } else if (str.toLowerCase() === "tuesday") {
    return 2
  } else if (str.toLowerCase() === "wednesday") {
    return 3
  } else if (str.toLowerCase() === "thursday") {
    return 4
  } else if (str.toLowerCase() === "friday") {
    return 5
  } else if (str.toLowerCase() === "saturday") {
    return 6
  } else if (str.toLowerCase() === "sunday") {
    return 0
  }
}

export const ERROR_MESSAGE = "Sepertinya ada yang tidak beres"

export const FORM_LOCAL_STORAGE_RIKJANG_HARGA = "_form_data_RIKJANG_harga"
export const FORM_LOCAL_STORAGE_RIKJANG_HARGA_CUSTOM =
  "_form_data_RIKJANG_harga_custom"

export const FORM_LOCAL_STORAGE_PAKET_HARGA = "_form_data_paket_harga"
export const FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM =
  "_form_data_paket_harga_custom"

export const TYPE_INSTANCE1 = "instance1"
export const TYPE_INSTANCE2 = "instance2"
export const TYPE_INSTANCE3 = "instance3"
export const TYPE_INSTANCE4 = "instance4"
export const TYPE_INSTANCE5 = "instance5"
export const TYPE_INSTANCE6 = "instance6"
export const TYPE_INSTANCEGO = "instanceGo"
export const TYPE_INSTANCEVCLAIM = "instanceVclaim"
export const TYPE_INSTANCEAPPLICARES = "instanceApplicares"
export const TYPE_SATU_SEHAT = "instanceSatuSehat"
export const TYPE_WS_BPJS_LIST_DOKTER = "instancewsbpjslistdokter"
export const TYPE_INSTANCE_MASTER_EMR = "instancePublicMasterEMR"
export const TYPE_INSTANCE_MASTER_EMR2 = "instancePublicMasterEMR2"
export const TYPE_INSTANCE_REGISTRASI_EMR_V3 = "instanceRegistrasiEMRV3"
export const TYPE_INSTANCE_HRIS = "instanceHRIS"

export const TYPE_TEST = "test_warehouss"
export const TYPE_KFA_TEST = "kfa_local"

export const TYPE_SATU_SEHAT_V2 = "instanceSatuSehatV2"
// MENU CODE
export const MS_AGAMA = "MS_ATR_AGM"
export const MS_SH_LOKASI = "MS_SH_LKS"
export const MS_SH_ORG = "MS_SH_ORG"
export const MS_SH_BDL = "MS_SH_BDL"
export const MS_SH_CTR = "MS_SH_CTR"
export const MS_SH_ECT = "MS_SH_ECT"
export const MS_SH_KFA = "MS_SH_KFA"
export const MS_SH_KYC = "MS_SH_KYC"
export const MS_BANK = "MS_ATR_BNK"
export const MS_KUALIFIKASI_PENDIDIKAN = "MS_ATR_KD"
export const MS_RUMAH_SAKIT = "MS_RS"
export const MS_SPESIALIS = "MS_SPS"
export const MS_PERUSAHAAN = "MS_PRS"
export const MS_TIPE_REGISTRASI = "MS_RGS_TR"
export const MS_KELAS_KUNJUNGAN = "MS_RGS_KK"
export const MS_POLIKLINIK = "MS_PLK_PL"
export const MS_POLIKLINIK_SPESIALIS = "MS_PLK_PLS"
export const MS_LAYANAN = "MS_LY_LY"
export const MS_LAYANAN_RUANG = "MS_LY_RL"
export const MS_JENIS_LAYANAN = "MS_LY_JL"
export const MS_JENIS_RAWAT = "MS_LY_JR"
export const MS_ASURANSI = "MS_ASR"
export const MS_KATEGORI = "MS_KS"

export const MS_LOKET_ANTRIAN_KUNJUNGAN = "MS_AL_TA"
export const MS_ANTRIAN_LOKET = "MS_AL_LKT"
export const MS_LOKET_TEXT_DISPLAY = "MS_TXT_TDL"
export const MS_KUNJUNGAN_TEXT_DISPLAY = "MS_TXT_TDK"

export const MS_FORMULA = "MS_WMS_FML"
export const MS_JENIS_HARGA = "MS_WMS_JHG"
export const MS_GOLONGAN_DARAH = "MS_ATR_GD"
export const MS_PENDIDIKAN = "MS_ATR_PD"
export const MS_SUKU_BANGSA = "MS_ATR_SB"
export const MS_PENANGGUNG_JAWAB = "MS_ATR_GCN"
export const MS_PEKERJAAN = "MS_ATR_PK"
export const MS_KAMAR = "MS_KAMAR"
export const MS_TARIF = "MS_TARIF"

export const MS_BED = "MS_BED"

export const MS_JENIS_JASA = "PNJL_JNS_JJ"
export const MS_JENIS_FASILITAS = "PNJL_JNS_JF"
export const MS_JENIS_RIKJANG = "PNJL_JNS_JR"
export const MS_JENIS_PAKET = "PNJL_JNS_JP"

export const MS_JASA = "PNJL_MS_MJ"
export const MS_RIKJANG = "PNJL_MS_MRJ"
export const MS_FASILITAS = "PNJL_MS_MF"
export const MS_PAKET = "PNJL_MS_MPK"
export const MS_TEMPLATE = "PNJL_MS_MT"
export const MS_HARGA_TARIF = "MS_HARGA_TARIF"
export const MS_UPDATE_HARGA_TARIF = "MS_UPDATE_HARGA_TARIF"

export const MS_TEMA = "MA_TM"

export const MS_TIPE_PEMBAYARAN = "PNJL_MS_TP"

export const MS_MOVIE_LIST = "MS_MV_ML"
export const MS_MOVIE_PROFILING = "MS_MV_MP"
export const MS_KAS = "MS_KAS"

export const MS_TAG = "MS_TAG"

export const INPUT_DOKTER = "MS_DKT_IDR"
export const JADWAL_DOKTER = "MS_DKT_JDD"
export const KUOTA_ONLINE_DOKTER = "MS_DKT_KO"
export const PERUBAHAN_JADWAL_DOKTER = "PERUBAHAN_JADWAL_DOKTER"
export const VERIFIKASI_BOOKING = "MM_VBO"

export const INPUT_EKLAIM = "BPJS_INPUT_EKLAIM"
export const BPJS_DAFTAR_TAGIHAN = "BPJS_DAFTAR_TAGIHAN"
export const PURIFIKASI = "BPJS_PURIFIKASI"
export const UPLOAD_MANUAL = "BPJS_UPLOAD_MANUAL"
export const REKONSILIASI = "BPJS_REKONSILIASI"
export const BPJS_KONIFG_RK = "BPJS_KONIFG_RK"
export const UPLOAD_MANUAL_KRONIS = "BPJS_UPLOAD_MANUAL_KRONIS"
export const REKONSILIASI_KRONIS = "BPJS_REKONSILIASI_KRONIS"
export const REKONSILIASI_BPJS = "BPJS_REKONSILIASI_BPJS"
export const BPJS_KONIFG_FR = "BPJS_KONIFG_FR"

export const LAPORAN_JASA_MEDIS = "LAPORAN_JASA_MEDIS"
// export const ADMINISTRATIF_BPJS = "BPJS_VCLAIM_REFENSI_ADMINISTRATIF";
export const BPJS_VCLAIM_REFENSI = "BPJS_VCLAIM_REFENSI"
export const BPJS_VCLAIM_PENGAJUAN = "BPJS_VCLAIM_PENGAJUAN"
export const BPJS_VCLAIM_APPROVAL = "BPJS_VCLAIM_APPROVAL"
export const BPJS_VCLAIM_UPDATE_TGL_PLG = "BPJS_VCLAIM_UPDATE_TGL_PLG"
export const BPJS_VCLAIM_RUJUKAN = "BPJS_VCLAIM_RUJUKAN"
export const BPJS_VCLAIM_RUJUKAN_KHUSUS = "BPJS_VCLAIM_RUJUKAN_KHUSUS"
export const BPJS_VCLAIM_PRB = "BPJS_VCLAIM_PRB"
export const BPJS_VCLAIM_SEP = "BPJS_VCLAIM_SEP"

export const BPJS_APOTEK = "BPJS_APOTEK"

export const BPJS_WSBPJS_REFERENSI = "BPJS_WSBPJS_REFERENSI"
export const BPJS_WSBPJS_ANTREAN = "BPJS_WSBPJS_ANTREAN"
export const BPJS_WSBPJS_DASHBOARD_WAKTU_TUNGGU =
  "BPJS_WSBPJS_DASHBOARD_WAKTU_TUNGGU"
export const BPJS_WSBPJS_REF_POLI_FINGERPRINT =
  "BPJS_WSBPJS_REF_POLI_FINGERPRINT"
export const BPJS_WSBPJS_REF_PASIEN_FINGERPRINT =
  "BPJS_WSBPJS_REF_PASIEN_FINGERPRINT"
export const BPJS_WSBPJS_TASKID = "BPJS_WSBPJS_TASKID"

export const MA_ROLE = "MA_RL"
export const MA_USER = "MA_USR"
export const MA_MENU = "MA_MN"
export const MA_ROLE_ACCESS = "MA_RAM"
export const MA_MENU_ACCESS = "MA_ACC"
export const MA_USER_ACCESS = "MA_USCC"
export const MA_VERIFIKASI_ACCESS = "MA_VACC"
export const MA_SET_SIMRS = "MA_SS"
export const MA_NOTIFIKASI = "MA_NFI"
export const MA_KONIFG_PENJUALAN = "MA_KNP"

export const MA_KONIFG_RS = "MA_KNRS"

export const WMS_MS_SUPPLIER = "WMS_MWM_SUP"
export const WMS_MS_GUDANG_UTAMA = "WMS_MWM_GU"
export const WMS_MS_SATUAN = "WMS_MWM_ST"
export const WMS_MS_PRODUSEN = "WMS_MWM_PRD"
export const WMS_MS_UNIT = "WMS_MWM_UNT"

export const WMS_PBF_MS_GUDANG = "WMS_PBF_MS_GDG"
export const WMS_PBF_MS_BARANG = "WMS_PBF_MS_BRG"
export const WMS_PBF_MS_KELAS_TERAPI = "WMS_PBF_MS_KT"
export const WMS_PBF_MS_JENIS_OBAT = "WMS_PBF_MS_JOB"
export const WMS_PBF_MS_GOLONGAN_OBAT = "WMS_PBF_MS_GOB"
export const WMS_PBF_MS_TARIF_CBG = "WMS_MWM_TBG"
export const WMS_PBF_MS_FORMULA_HARGA = "WMS_PBF_MS_FH"
export const WMS_PBF_MS_FORMULA = "WMS_PBF_MS_FML"
export const WMS_PBF_MS_JENIS_HARGA = "WMS_PBF_MS_JHG"

export const WMS_PBF_PO = "WMS_PBF_TGU_PO"
export const NAME_WMS_PBF_PO = "PURCHASE ORDER"

export const WMS_PBF_DAFTAR_PO = "WMS_PBF_TGU_DPO"
export const WMS_SERVICE_TUTUP_PEMBELIAN = "WMS_PBF_TGU_STP"
export const NAME_WMS_PBF_PEMBELIAN = "Pembelian"
export const WMS_PBF_PEMBELIAN = "WMS_PBF_TGU_PMB"

export const WMS_PBF_DAFTAR_PEMBELIAN = "WMS_PBF_TGU_DPM"

export const WMS_PBF_INVENTORY_CONTROL = "WMS_PBF_ICM_IC"
export const WMS_PBF_DAFTAR_ADJUSMENT_STOCK = "WMS_PBF_ICM_DAS"
export const WMS_PBF_DAFTAR_ADJUSMENT_UNIT = "WMS_PBF_ICM_DAU"

export const WMS_PBF_MUTASI_ITEM = "WMS_PBF_ICM_MI"
export const WMS_PBF_DAFTAR_MUTASI_ITEM = "WMS_PBF_ICM_DMI"
export const WMS_PBF_TRACKING_NARKOTIK = "WMS_PBF_ICM_TRN"

export const WMS_PBF_RETUR_PEMBELIAN = "WMS_PBF_TGU_RPB"
export const WMS_PBF_INPUT_REQUEST_MUTASI = "WMS_PBF_ICM_IRM"
export const WMS_PBF_RECEIVE_REQUEST_MUTASI = "WMS_PBF_ICM_RRM"
export const WMS_PBF_INPUT_ADJUSMENT_STOCK = "WMS_PBF_ICM_IAS"
export const WMS_PBF_INPUT_ADJUSMENT_UNIT = "WMS_PBF_ICM_IAU"
export const WMS_PBF_DAFTAR_STOCK_OPNAME = "WMS_PBF_ICM_DSO"
export const WMS_PBF_STOCK_OPNAME = "WMS_PBF_ICM_SOP"
export const WMS_PBF_PEMBAYARAN = "WMS_PBF_TGU_PMBY"
export const WMS_PBF_DAFTAR_PEMBAYARAN = "WMS_PBF_TGU_DPR"
export const WMS_PBF_LAP_PEMBELIAN = "WMS_PBF_LPF_LPB"
export const WMS_PBF_LPF_LAPORAN_HISTORY_NARKOTIK = "WMS_PBF_LPF_LHN"
export const WMS_PBF_HISTORY_STOK = "WMS_PBF_LPF_LHS"
export const WMS_PBF_KARTU_STOK = "WMS_PBF_LPF_LKS"
export const WMS_PBF_FORECASTING = "WMS_PBF_FORECASTING"

export const WMS_LGS_MS_BARANG = "WMS_LGS_MS_BRG"
export const WMS_LGS_MS_GUDANG = "WMS_LGS_MS_GDG"
export const WMS_LGS_GOL_BARANG = "WMS_LGS_MS_GBA"
export const WMS_LGS_MS_SPB = "WMS_LGS_MS_SPB"

export const WMS_LGS_PO = "WMS_LGS_TGU_PO"
export const NAME_WMS_LGS_PO = "PURCHASE ORDER"
export const WMS_LGS_PEMBELIAN = "WMS_LGS_TGU_PMB"
export const WMS_LGS_INPUT_REQUEST_MUTASI = "WMS_LGS_ICM_IRM"
export const WMS_LGS_DAFTAR_MUTASI_ITEM = "WMS_LGS_ICM_DMI"
export const WMS_LGS_RECEIVE_REQUEST_MUTASI = "WMS_LGS_ICM_RRM"
export const WMS_LGS_MUTASI_ITEM = "WMS_LGS_ICM_MI"
export const WMS_LGS_DAFTAR_ADJUSMENT_STOCK = "WMS_LGS_ICM_DAS"
export const WMS_LGS_INPUT_ADJUSMENT_STOCK = "WMS_LGS_ICM_IAS"
export const WMS_LGS_INVENTORY_CONTROL = "WMS_LGS_ICM_IC"
export const WMS_LGS_DAFTAR_ADJUST = "WMS_LGS_ICM_DUS"
export const WMS_LGS_INPUT_ADJUST = "WMS_LGS_ICM_JUS"

export const WMS_LGS_DAFTAR_PO = "WMS_LGS_TGU_DPO"
export const WMS_LGS_PEMBAYARAN = "WMS_LGS_TGU_PMBY"
export const WMS_LGS_DAFTAR_PEMBAYARAN = "WMS_LGS_TGU_DP"
export const WMS_LGS_DAFTAR_PEMBELIAN = "WMS_LGS_TGU_DPM"
export const WMS_LGS_DAFTAR_STOCK_OPNAME = "WMS_LGS_ICM_DSO"
export const WMS_LGS_STOCK_OPNAME = "WMS_LGS_ICM_SO"
export const WMS_SERVICE_TUTUP_PEMBELIAN_LOGISTIK = "WMS_LGS_TGU_STP"
export const WMS_LGS_RETUR_PEMBELIAN = "WMS_LGS_TGU_RPB"

export const WMS_LGS_HISTORY_STOK = "WMS_LGS_LPL_HSL"
export const WMS_LGS_KARTU_STOK = "WMS_LGS_LPL_LKS"
export const WMS_LGS_LAPORAN_STOK = "WMS_LGS_LPL_LSL"

export const WMS_FA_ATR_DEPRECIATION = "WMS_FA_ATR_DM"
export const WMS_FA_ATR_TIPE_FISCAL = "WMS_FA_ATR_TF"
export const WMS_FA_ATR_TIPE_ASSET = "WMS_FA_ATR_TA"

export const WMS_FA_ATR_TINGKAT_ASSET = "WMS_FA_ATR_FA"
export const WMS_FA_MS_TIPE_NOTIFIKASI = "WMS_FA_MS_TN"
export const WMS_FA_MS_GUDANG = "WMS_FA_MS_GDG"
export const WMS_FA_MS_GOL_BARANG = "WMS_FA_MS_GBA"
export const WMS_FA_MS_VD = "WMS_FA_MS_VD"

export const WMS_FA_REQUEST = "WMS_FA_TRS_RFA"
export const WMS_FA_PENGAJUAN = "WMS_FA_TRS_PGN"
export const WMS_FA_INPUT = "WMS_FA_TRS_IFA"
export const NAME_WMS_FA_INPUT = "Input Fixed Asset"

export const WMS_FA_DAFTAR_PO = "WMS_FA_TRS_DPO"
export const WMS_FA_PO = "WMS_FA_TRS_PO"
export const NAME_WMS_FA_PO = "PURCHASE ORDER"
export const WMS_FA_PEMBAYARAN = "WMS_FA_TRS_PMBY"
export const WMS_FA_PEMBELIAN = "WMS_FA_TRS_PMB"
export const FORM_LOCAL_STORAGE_WMS_FA_PEMBELIAN = "_form_data_wms_fa_pembelian"
export const WMS_FA_DAFTAR_PEMBAYARAN = "WMS_FA_TRS_DP"
export const WMS_FA_DAFTAR_PEMBELIAN = "WMS_FA_TRS_DPM"
export const WMS_SERVICE_TUTUP_PEMBELIAN_FIXED_ASSET = "WMS_FA_TRS_STP"
export const WMS_FA_RETUR_PEMBELIAN = "WMS_FA_TRS_RPB"
export const WMS_FA_DAFTAR_REQUEST = "WMS_FA_TRS_DRFA"
export const WMS_FA_PENGAJUAN_REQUEST = "WMS_FA_TRS_PR"
export const WMS_FA_DAFTAR = "WMS_FA_TRS_DFA"
export const WMS_FA_MANAJEMEN_NOTIFIKASI = "WMS_FA_TRS_MN"
export const WMS_FA_TRANSFER_ASSET = "WMS_FA_TRS_TA"
export const WMS_FA_DAFTAR_TRANSFER_ASSET = "WMS_FA_TRS_DTA"
export const WMS_FA_DAFTAR_KESELURUHAN_TRANSFER = "WMS_FA_TRS_DKT"
export const WMS_FA_DISPOSE_ASSET = "WMS_FA_TRS_DA"
export const WMS_FA_DAFTAR_NOTIFIKASI_ASSET = "WMS_FA_TRS_NA"
export const WMS_FA_KALIBRASI = "WMS_FA_TRS_KB"
export const WMS_FA_HELPDESK = "WMS_FA_MT_HD"
export const WMS_FA_DAFTAR_HELPDESK = "WMS_FA_MT_DHD"
export const WMS_FA_INPUT_MAINTENANCE = "WMS_FA_MT_IMT"
export const WMS_FA_DAFTAR_MAINTENANCE = "WMS_FA_MT_DMT"

export const ANTRIAN_DISPLAY = "MM_ANT_DSP"
export const ANTRIAN_QUEUE = "MM_ANT_QUE"

export const BILLING_INPUT_PENJUALAN = "PNJL_TRX_INP"
export const BILLING_DAFTAR_PENJUALAN = "PNJL_TRX_DTP"
export const BILLING_LAPORAN_PENJUALAN = "PNJL_LAP_PENJ"
export const BILLING_SERVICE_TUTUP_PENJUALAN = "PNJL_TRX_STP"

export const BILLING_REKAP_JASMED = "TRANSAKSI_REKAP_JASMED"
export const BILLING_MS_RINCIAN_JASMED = "MS_RINCIAN_JASMED"
export const BILLING_REKAP_DETAIL_JASMED = "TRANSAKI_DETAIL_REKAP_JASMED"

export const BILLING_INPUT_TAGIHAN = "TGH_ITG"
export const BILLING_DAFTAR_TAGIHAN = "TGH_DTG"
export const BILLING_RETUR_PENJUALAN = "PNJL_TRX_RPJ"
export const BILLING_SERVICE_TUTUP_TAGIHAN = "TGH_STT"
export const BILLING_AUTO_TAGIHAN = "TGH_ATN"

export const SETTING_AUTO_BILLING = "PNJL_SETG_OTMS"

export const BILLING_SALDO = "TGH_SLD"
export const BILLING_DAFTAR_PEMBAYARAN_TAGIHAN = "TGH_DPT"

export const KUNJUNGAN_RAWAT_JALAN = "KUNJUNGAN_RAWAT_JALAN"
export const KUNJUNGAN_RAWAT_INAP = "KUNJUNGAN_RAWAT_INAP"
export const KUNJUNGAN_IGD = "KUNJUNGAN_IGD"

export const BILLING_HR_KAS_BON_DOKTER = "HR_KBD"

// REQUEST BARANG

export const RB_REQUEST = "RB_IRB"
export const RB_DAFTAR_REQUEST = "RB_DRB"
export const RB_PENGAJUAN = "RB_PRB"
export const RB_DAFTAR_PENGAJUAN = "RB_DPRB"

//REGISTRASI
export const REG_RJ = "REG_RJ"
export const REG_RI = "REG_RI"
export const REG_IGD = "REG_IGD"
export const REG_BA = "REG_BA"
export const REK_MED = "MM_PRM"
export const REG_GRM = "REG_GRM"

export const MM_BED = "MM_BED"

//ANTRIAN LOKET
export const LOC_CALL = "ANT_LOC"
export const KAS_CALL = "ANT_KC"
export const FAR_CALL = "ANT_FC"
export const LAY_CALL = "ANT_LAC"
export const POLI_CALL = "ANT_PC"

//BED
export const MOB_FAQ = "MBL_FAQ"
export const MOB_SLIDER = "MBL_SLD"
export const MOBILE_USER = "MBL_USR"
export const MOBILE_JADWAL_TELEKONSUL = "MBL_TKS_JDT"
export const MOBILE_TARIF_TELEKONSUL = "MBL_TKS_TRT"
export const MOBILE_PEMBELIAN_TELEKONSUL = "MBL_TKS_PBL"
export const MOBILE_PEMBAYARAN_TELEKONSUL = "MBL_TKS_PBY"
export const MOBILE_INPUT_PAKET_TELEKONSUL = "MBL_TKS_IPKT"
export const MOBILE_DAFTAR_PAKET_TELEKONSUL = "MBL_DPKT"

export const GUDANG_ACCESS_CODE = "GDG"

// LAPORAN
export const LN_LAPORAN_SERVICE = "LN_LNS"
export const LN_STATUS_SERVICE = "LN_SS"
export const LN_LAPORAN_INCOME = "LN_LI"
export const LN_LAPORAN_REGISTRASI = "LN_LR"
export const LN_LAPORAN_LOG_BRIDGING = "LN_LLB"
export const LN_LAPORAN_ANTRIAN_JKN = "LAP_ANTRIAN_JKN"
export const LN_LAPORAN_JADWAL_DOKTER = "LAP_JADWAL_DOKTER"
export const LN_LAPORAN_JADWAL_OPERASI = "LN_JO"

// Akuntantsi
export const AKT_MASTER_COA = "AKT_MS_COA"
export const AKT_MS_TIPE_PENERIMA = "AKT_MS_TIPE_PENERIMA"
export const AKT_MS_TIPE_GL = "AKT_MS_TIPE_GL"
export const AKT_MS_SETTING_NERACA = "AKT_MS_SETTING_NERACA"
export const AKT_MS_TARGET_PENDAPATAN = "AKT_MS_TRGT_PNDPTN"
export const AKT_MS_SETTING_LABA_RUGI = "AKT_MS_SETTING_LABA_RUGI"
export const AKT_MS_PERIODE = "AKT_MS_PERIODE"
export const AKT_MS_SETTING_CASHFLOW = "AKT_MS_SETTING_CASHFLOW"
export const AKT_MS_SALDO_AWAL = "AKT_MS_SLD_AWAL"

export const AKT_DAFTAR_JURNAL = "AKT_DAFTAR_JURNAL"
export const AKT_JURNAL_UMUM = "AKT_JURNAL_UMUM"
export const AKT_JURNAL_PENUTUP = "AKT_JURNAL_PENUTUP"
export const AKT_BUKU_BESAR = "AKT_BUKU_BESAR"
export const AKT_LABA_RUGI = "AKT_LABA_RUGI"
export const AKT_LABA_RUGI_DETAIL = "AKT_LABA_RUGI_DETAIL"
export const AKT_NERACA_SALDO = "AKT_NERACA_SALDO"
export const AKT_NERACA_BULAN = "AKT_NERACA_BULAN"
export const AKT_NERACA_BULAN_DETAIL = "AKT_NERACA_BULAN_DETAIL"
export const AKT_SYNCHRONIZE = "AKT_SYNCHRONIZE"
export const AKT_LAP_NERACA = "AKT_LAP_NERACA"
export const AKT_LAP_LABA_RUGI = "AKT_LAP_LABA_RUGI"
export const AKT_LAP_CASHFLOW = "AKT_LAP_CASHFLOW"
export const AKT_LAP_LABA_RUGI_V2 = "AKT_LAP_LABA_RUGI_V2"
export const AKT_LAP_NERACA_V2 = "AKT_LAP_NERACA_V2"
export const AKT_LAP_REKAP_NERACA_V2 = "AKT_LAP_REKAP_NERACA_V2"
export const AKT_LAP_REKAP_LABA_RUGI_V2 = "AKT_LAP_REKAP_LABA_RUGI_V2"

export const SETTING_DASHBOARD = "EXC_SETT_DASH"
export const DASHBOARD = "EXC_DASH"

// Rekap Tagihan
export const RT_INPUT_REKAP_TAGIHAN = "RT_IRT"
export const RT_DAFTAR_REKAP_TAGIHAN = "RT_DRT"
export const RT_DAFTAR_PEMBAYARAN_REKAP = "RT_DPR"
export const RT_AGGING_PIUTANG_REKAP = "RT_APR"

export const CSMX_RGKS_PSN_PLG_RAJAL = "CSMX_RGKS_PSN_PLG_RAJAL"
export const CSMX_RGKS_PSN_PLG_RANAP = "CSMX_RGKS_PSN_PLG_RANAP"
export const CSMX_RGKS_PSN_PLG_HD = "CSMX_RGKS_PSN_PLG_HD"
export const CSMX_RGKS_PSN_PLG_IGD = "CSMX_RGKS_PSN_PLG_IGD"
export const CSMX_RGKS_PSN_PLG_LO = "CSMX_RGKS_PSN_PLG_LO"
export const CSMX_RGKS_PSN_PLG_FT = "CSMX_RGKS_PSN_PLG_FT"
export const CSMX_RGKS_PSN_PLG_LT = "CSMX_RGKS_PSN_PLG_LT"
export const CSMX_MRP = "CSMX_MRP"
export const CSMX_DSG = "CSMX_DSG"

export const isSSO = process.env.REACT_APP_SSO === "true"

// WS BRIDGING BPJS
export const WS_RKN_DKT = "WS_RKN_DKT"
export const WS_RKN_SEP = "WS_RKN_SEP"
export const WS_MTR_KLM = "WS_MTR_KLM"
export const WS_MTR_KNJ = "WS_MTR_KNJ"
export const WS_MTR_PLN = "WS_MTR_PLN"
export const WS_MTR_JMN = "WS_MTR_JMN"
export const WS_PST_BPJS = "WS_PST_BPJS"
export const WS_PST_NIK = "WS_PST_NIK"
export const WS_SEP_SEP = "WS_SEP_SEP"
export const WS_RJK_RMR = "WS_RJK_RMR"
export const WS_RJK_SRN = "WS_RJK_SRN"
export const WS_RJK_KRS = "WS_RJK_KRS"

export const JENIS_RAWAT = {
  RAWAT_JALAN: "RJALAN",
  RAWAT_INAP: "RINAP",
  IGD: "IGD",

  // IGD_ID: 1,

  // RJALAN: 'Rawat Jalan',
  // RINAP: 'Rawat Inap',
  // OP: 'Operasi',
  // HD: 'Hemodialisa',

  // FISRJ: 'Fisioterapi Rawat Jalan',
  // FISRI: 'Fisioterapi Rawat Inap',

  // FARRJ: 'Farmasi Klinis Rawat Jalan',
  // FARRI: 'Farmasi Klinis Rawat Inap',

  // GIZI: 'Gizi',
}
